<template>
  <div v-if="!loading && boletimSanitario && boletimSanitario.idBoletimSanitario > 0"
       class="route-view-card ma-0 pa-15 pt-10 fill-height d-flex flex-column">
    <!-- HEADER -->
    <div class="d-column wrapper border-y border-x"
         style="min-height: 76px; justify-content: space-between;">
      <div style="text-align: right;">(Anexo Circular 5/2009/DICS/CGI/DIPOA)</div>
      <div class="text_002" style="text-align: center;">BOLETIM SANITÁRIO DE ACOMPANHAMENTO DE SUÍNOS</div>
      <div style="text-align: right;">Nr.:{{ boletimSanitario.idBoletimSanitario }}</div>
    </div>

    <!-- Informações Estabelecimento -->
    <div class="grid-info wrapper border-x">
      <div>Produtor</div>
      <div>{{ boletimSanitario.nmProdutor }}</div>
      <div></div>
      <div></div>

      <div>Estabelecimento</div>
      <div>{{ boletimSanitario.nmEstabelecimento }}</div>
      <div></div>
      <div></div>

      <div>Responsável Técnico</div>
      <div>{{ boletimSanitario.nmResponsavelTecnico }}</div>
      <div></div>
      <div></div>

      <div>Nr. Cadastro Órgão Estadual de Defesa</div>
      <div>{{ boletimSanitario.nrOrgaoOficial }}</div>
      <div></div>
      <div></div>


      <div>Georreferenciamento</div>
      <div>Lat.: {{ boletimSanitario.nrLatitude }}</div>
      <div>Long.: {{ boletimSanitario.nrLongitude }}</div>
      <div></div>

      <div>Município</div>
      <div>{{ boletimSanitario.nmMunicipio }}</div>
      <div></div>
      <div>UF: {{ boletimSanitario.sgUf }}</div>
    </div>


    <!-- Tipo Responsável -->
    <div class="wrapper d-column border-t border-x">
      <div>Responsável pelas Informações:</div>
      <div class="grid-row3" style="padding: 12px; padding-top: 4px;">
        <div class="grid-item" style="display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="border-y border-x center-icon" style="width: 18px; height: 18px; margin-right: 4px;">
            <v-icon v-if="boletimSanitario.csResponsavelInformacoes === 'MO'">
              fas fa-times
            </v-icon>
          </div>
          Médico Veterinário Oficial / Habilitado
        </div>
        <div class="grid-item" style="display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="border-y border-x center-icon" style="width: 18px; height: 18px; margin-right: 4px;">
            <v-icon v-if="boletimSanitario.csResponsavelInformacoes === 'MP'">
              fas fa-times
            </v-icon>
          </div>
          Médico Veterinário Particular
        </div>
        <div class="grid-item" style="display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="border-y border-x center-icon" style="width: 18px; height: 18px; margin-right: 4px;">
            <v-icon v-if="boletimSanitario.csResponsavelInformacoes === 'PR'">
              fas fa-times
            </v-icon>
          </div>
          Proprietário
        </div>
      </div>
    </div>

    <!-- Tipo Rastreabilidade -->
    <div class="wrapper d-column border-t border-x">
      <div>Rastreabilidade:</div>
      <div class="grid-row3" style="padding: 12px; padding-top: 4px;">
        <div class="grid-item" style="display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="border-y border-x center-icon" style="width: 18px; height: 18px; margin-right: 4px;">
            <v-icon v-if="boletimSanitario.csRastreabilidade === 'CC'">
              fas fa-times
            </v-icon>
          </div>
          Ciclo Completo
        </div>
        <div class="grid-item" style="display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="border-y border-x center-icon" style="width: 18px; height: 18px; margin-right: 4px;">
            <v-icon v-if="boletimSanitario.csRastreabilidade === 'TE'">
              fas fa-times
            </v-icon>
          </div>
          Terminador
        </div>
        <div class="grid-item" style="display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="border-y border-x center-icon" style="width: 18px; height: 18px; margin-right: 4px;">
            <v-icon v-if="boletimSanitario.csRastreabilidade === 'RD'">
              fas fa-times
            </v-icon>
          </div>
          Reprodutor/Descarte
        </div>
      </div>
    </div>

    <!-- Origens -->
    <table>
      <tr>
        <th>
          Carga de Leitões <span style="font-size: 12px;">(1)</span>
        </th>
        <th>
          Nr. GTA dos leitões
        </th>
        <th>
          Nr. de leitões declarados na GTA
        </th>
        <th>
          Nr. de leitões mortos no transporte
        </th>
        <th>
          Data Alojamento
        </th>
        <th>
          Nr. Leitões Alojados
        </th>
      </tr>
      <!-- Dados Origens -->
      <tr v-for="(origem, idx) in boletimSanitario.origens" :key="idx">
        <td align="center">
          {{ origem.nrCarga }}
        </td>
        <td align="center">
          {{ origem.nrGta }}-{{ origem.dsSerieGta }}
        </td>
        <td class="p-data" align="right">
          {{ origem.qtAnimaisSaida }}
        </td>
        <td align="center">
          {{ origem.qtMortosEmTransporte }}
        </td>
        <td align="center">
          {{ origem.dtEntrada }}
        </td>
        <td class="p-data" align="right">
          {{ origem.qtAnimais }}
        </td>
      </tr>
      <!-- Total Origens -->
      <tr class="borderless">
        <td></td>
        <td></td>
        <td class="p-data" align="right">{{ boletimSanitario.origens | somaTotalQtAnimaisSaida }}</td>
        <td></td>
        <td></td>
        <td class="p-data" align="right">{{ boletimSanitario.origens | somaTotalQtAnimais }}</td>
      </tr>
    </table>


    <!-- Saidas -->
    <table style="border-top: 0px;">
      <tr>
        <th>
          Carga de Suínos para Abate <span style="font-size: 12px;">(1)</span>
        </th>
        <th>
          Nr. GTA dos suínos para o abate
        </th>
        <th>
          Data de Emissão GTA
        </th>
        <th>
          Data de Carregamento
        </th>
        <th>
          Nr. de suínos na data de emissão do boletim
        </th>
        <th>
          % de mortalidade na emissão do boletim <span style="font-size: 12px;">(2)</span>
        </th>
      </tr>
      <!-- Dados Saidas -->
      <tr v-for="(saida, idx) in boletimSanitario.saidaAnimais" :key="idx">
        <td align="center">
          {{ saida.nrCarga }}
        </td>
        <td align="center">
          {{ saida.nrGta }}-{{ saida.dsSerieGta }}
        </td>
        <td class="p-data" align="right">
          {{ saida.dtEmissao }}
        </td>
        <td align="center">
          {{ saida.dtSaida }}
        </td>
        <td align="center">
          {{ saida.qtAnimais }}
        </td>
        <td class="p-data" align="right">
          {{ saida.peMortalidade }}
        </td>
      </tr>

      <!-- Total Saidas -->
      <tr class="borderless">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="p-data" align="center">{{ boletimSanitario.saidaAnimais | somaTotalQtAnimais }}</td>
        <td></td>
      </tr>
    </table>

    <!-- Suínos remanescentes -->
    <div class="wrapper border-t border-x">
      Número de suínos remanescentes do lote <span
        style="font-size: 12px;">(3)</span>: {{ boletimSanitario.qtAnimaisRemanescentes }}
    </div>
    <div class="wrapper border-t border-x">
      % Mortalidade após a finalização do lote <span style="font-size: 12px;">(4)</span>:
      {{ !boletimSanitario.peMortalidadeFinalLote ? 'Lote não finalizado' : boletimSanitario.peMortalidadeFinalLote }}
    </div>
    <div class="wrapper d-column border-t border-x">
      <div>
        Sinais clínicos/doenças detectadas pelo responsável técnico do lote <span style="font-size: 12px;">(5)</span>
      </div>
      <div>
        {{ boletimSanitario.dsSinaisClinicos }}
        {{
          !boletimSanitario.blNotificacaoObrigatoria ?
              'NÃO HOUVE OCORRÊNCIA DE SINAIS CLÍNICOS DE DOENÇAS DE NOTIFICACÃO OBRIGATÓRIA' :
              'HOUVE OCORRÊNCIA DE SINAIS CLÍNICOS DE DOENÇAS DE NOTIFICACÃO OBRIGATÓRIA'
        }}
      </div>
    </div>

    <!-- Medicamentos -->
    <table>
      <!-- Pré-Cabeçalho -->
      <tr>
        <th class="pb-0" colspan="4" style="text-align: left;">
          Drogas administradas no lote<span style="font-size: 12px;"> (6)</span>
        </th>
        <th class="pb-0" colspan="2" align="center">
          Vacinações
        </th>
      </tr>
      <!-- Cabeçalho -->
      <tr>
        <th>
          Princípio Ativo
        </th>
        <th style="max-width: 90px; min-width: 90px;">
          Data Início
        </th>
        <th style="max-width: 90px; min-width: 90px;">
          Data de Liberação para Abate
        </th>
        <th style="max-width: 120px; min-width: 100px;">
          Atendeu o período de carência? <br /> (SIM/NÃO)
        </th>
        <th style="max-width: 90px; min-width: 90px;">
          Data
        </th>
        <th style="max-width: 90px; min-width: 90px;">
          Vacina Administrada
        </th>
      </tr>
      <!-- Dados Medicamentos -->
      <tr v-for="(admFarmaco, idx) in medicamentosAdministrados" :key="idx">
        <td align="left">
          {{ admFarmaco.dsPrincipioAtivo }}
        </td>
        <td align="center">
          {{ admFarmaco.dtInicioTratamento }}
        </td>
        <td align="center">
          {{ admFarmaco.dtLiberacaoAbate }}
        </td>
        <td align="center">
          {{ admFarmaco.flAtendeuCarencia ? 'SIM' : 'NÃO' }}
        </td>
        <td align="center" v-if="idx !== 0 || boletimSanitario.vacinas.length !== 0">
          {{ admFarmaco.dtInicioTratamentoVacina }}
        </td>
        <td v-if="idx !== 0 || boletimSanitario.vacinas.length !== 0">
          {{ admFarmaco.nmFarmacoVacina }}
        </td>
        <td align="center" colspan="2" v-if="idx === 0 && boletimSanitario.vacinas.length === 0">
          Sem Administração de Vacina
        </td>

      </tr>
    </table>

    <div class="wrapper border-x">
      Data e hora da retirada da alimentação na granja: {{ boletimSanitario.dtRetiradaRacao }}
      {{ boletimSanitario.hrRetiradaRacao }}
    </div>
    <div class="wrapper border-t border-x">
      O abaixo assinado declara que os registros e documentos relativos a estes animais estão em conformidade com os requisitos legais, e os animais acima identificados, de
      acordo com os controles veterinários desenvolvidos na granja, foram considerados saudáveis durante a avaliação prévia do abate no momento da emissão do presente
      documento. Qualquer suspeita/diagnóstico laboratorial de importância de saúde pública ou animal está notificado no verso.
    </div>
    <!-- Assinatura Responsável Técnico -->
    <div class="wrapper prevent-break border-x border-y"
         style="display: flex; justify-content: space-around; align-items: flex-end; text-align: center; min-height: 140px;">
      <div class="sign-field">
        <div style="border-bottom: 1px solid black; min-width: 250px; padding: 0 4px 0 4px;">
          {{ boletimSanitario.nmMunicipioEmissao }} {{ boletimSanitario.dtEmissao }} {{ boletimSanitario.hrEmissao }}
        </div>
        <div>
          (local) data e hora
        </div>
      </div>
      <div class="sign-field">
        <div style="border-bottom: 1px solid black; min-width: 250px; padding: 0 4px 0 4px;">
          {{ boletimSanitario.nmResponsavelTecnico }}
        </div>
        <div style="padding: 0 8px 0 8px;">
          Identificação e Assinatura do Responsável pelas Informações
        </div>
      </div>
    </div>
    <div class="wrapper d-column border-x border-y">
      Declaro que as informações contidas neste boletim foram por mim verificadas, sendo consideradas de acordo com os requisitos sanitários do país a que se destina,
      conforme as informações adicionais no verso (declarações adicionais e respaldo para certificação sanitário no verso). (7)
    </div>

    <!-- Assinatura Veterinário -->
    <div class="wrapper prevent-break border-x border-b"
         style="display: flex; justify-content: space-around; align-items: flex-end; text-align: center; height: 140px;">
      <div class="sign-field">
        <div style="border-bottom: 1px solid black; min-width: 250px; padding: 0 4px 0 4px;">
          {{ boletimSanitario.nmMunicipioEmissao }} {{ boletimSanitario.dtEmissao }} {{ boletimSanitario.hrEmissao }}
        </div>
        <div>
          (local) data e hora
        </div>
      </div>
      <div class="sign-field">
        <div style="border-bottom: 1px solid black; min-width: 250px; padding: 0 4px 0 4px;">

        </div>
        <div style="padding: 0 8px 0 8px;">
          Carimbo e assinatura do Médico Veterinário responsável pela saúde do lote
        </div>
      </div>
    </div>
    <div class="prevent-break">
      <div class="header border-x border-y sif-title">
        <div>
          USO DO SERVIÇO OFICIAL - SIF
        </div>
        <div>
          VERIFICAÇÕES OFICIAIS/AÇÕES FISCAIS
        </div>
      </div>
      <div class="d-column bordert-t border-x">
        <div style="display: grid; grid-template-columns: auto 100px 100px;">
          <div style="border-right: #000000 1px solid; padding: 8px;">
            Apresentação de sinais clínicos compatíveis com doença de notificação obrigatória no Ante Mortem
          </div>
          <div style="display: flex; flex-wrap: nowrap; justify-self: center; align-items: flex-end; padding: 8px;">
            <div class="border-y border-x center" style="width: 18px; height: 18px; margin-right: 4px;">
            </div>
            Sim
          </div>
          <div style="display: flex; flex-wrap: nowrap; justify-self: center; align-items: flex-end; padding: 8px;">
            <div class="border-y border-x center" style="width: 18px; height: 18px; margin-right: 4px;">
            </div>
            Não
          </div>
        </div>

        <div style="display: grid; grid-template-columns: auto 100px 100px;">
          <div style="border-right: #000000 1px solid; padding: 8px;">
            Lote verificado e liberado pelo SIF para abate
          </div>

          <div style="display: flex; flex-wrap: nowrap; justify-self: center; align-items: flex-end; padding: 8px;">
            <div class="border-y border-x center" style="width: 18px; height: 18px; margin-right: 4px;">
            </div>
            Sim
          </div>
          <div style="display: flex; flex-wrap: nowrap; justify-self: center; align-items: flex-end; padding: 8px;">
            <div class="border-y border-x center" style="width: 18px; height: 18px; margin-right: 4px;">
            </div>
            Não
          </div>
        </div>
      </div>

      <div class="wrapper prevent-break d-column border-y border-x"
           style="min-height: 140px; justify-content: space-between;">
        <div>Outras observações no verso</div>
        <div style="display: flex; flex-direction: row; justify-content: space-between;">
          <div>Carimbo Datador</div>
          <div
              style="border-top: #000000 1px solid; min-width: 250px; text-align: center; margin-right: 8px;">Carimbo e assinatura FFA
          </div>
        </div>
      </div>
    </div>

    <div class="text_004 d-column" style="margin-top: 24px;">
      <div
          class="mb-2">(1) Para utilização no caso de mais de uma carga por lote, transporte em datas diferentes (por ex. 1ª carga, 2º carga etc). Poderão ser incluidas mais linhas quando houver um número maior de cargas;
      </div>
      <div
          class="mb-2">(2) Informar a % de suínos mortos do alojamento até a data de emissão do boletim (Nº de suínos vivos X 100/nº suínos alojados);
      </div>
      <div class="mb-2">(3) Nº de suínos que permaneceram na granja apos a carga parcial;</div>
      <div
          class="mb-2">(4) % de mortalidade na emissão do boletim + mortalidade entre emissão do boletim e a chegada dos suínos no frigorifico;
      </div>
      <div
          class="mb-2">(5) Sinais clinicos e doenças de notificação obrigatória detectadas no lote deverão ser informadas pelo responsável pelo lote ao Serviço de Defesa Sanitária Oficial do Estado;
      </div>
      <div
          class="mb-2">(6) Incluir drogas terapêuticas e não terapêuticas como os melhoradores de desempenho e outros;
      </div>
      <div
          class="mb-2">(7) Respaldo para atendimento de mercado específico (A propriedade atende a critérios de biossegurança específicos, bem estar animal, restrições de trânsito previstas na legislação ou exigidas pelos países importadores, etc...)
      </div>
    </div>
    <!-- Mensagens boletim sanitário -->
    <div style="margin-top: 24px;">
      <div class="dashed-b">
        EM ATENDIMENTO ÁS EXIGÊNCIAS A SEREM CUMPRIDAS PARA DESTINAÇÃO DE LOTES AOS MERCADOS AOS QUAIS OS ABATEDOUROS ESTÃO HABILITADOS, DECLARAMOS:
      </div>
      <ol>
        <li v-for="(mensagem, idx) in boletimSanitario.mensagensBoletimSanitario" :key="idx">
          {{ mensagem }}
        </li>
      </ol>
    </div>

    <!-- boletins anteriores -->
    <table class="mt-4" v-if="boletimSanitario.boletinsAnteriores.length > 0">
      <!-- header -->
      <tr>
        <th>Nº B.S.</th>
        <th>Nr. Carga</th>
        <th>Data de Carregamento</th>
        <th>GTA</th>
        <th>Qtd. Animais</th>
        <th>Destino</th>
        <th>Município Destino</th>
      </tr>
      <template v-for="(boletim) in boletimSanitario.boletinsAnteriores">
      <!-- linhas -->
        <tr v-for="(saida, idx) in boletim.saidasAnimais" :key="idx+'_boletim_'+boletim.idBoletimSanitario">
          <td align="center">{{ boletim.idBoletimSanitario }}</td>
          <td align="center">{{ saida.nrCarga }}</td>
          <td align="center">{{ saida.dtSaida }}</td>
          <td align="center">{{ saida.nrGta }}-{{ saida.dsSerieGta }}</td>
          <td align="center">{{ saida.qtAnimais }}</td>
          <td align="center">SIF: {{ saida.nrRegistroSif }} - {{ saida.nmPlantaAbate }}</td>
          <td align="center">{{ saida.nmMunicipio }} - {{ saida.sgUf }}</td>
        </tr>

        <!-- Linha Total -->
        <tr class="borderless border-b" :key="'qtdTotal_' + boletim.idBoletimSanitario">
          <td colspan="4" align="right"> Total de Animais</td>
          <td align="center">{{ boletim.saidasAnimais | somaTotalQtAnimais }}</td>
          <td colspan="2"></td>
        </tr>
      </template>
    </table>

  </div>
  <loading-state v-else/>
</template>

<script>
import LoadingState from "./LoadingState";
export default {
  name: "ResumoBoletimSanitario",
  components: {LoadingState},
  data: () => ({
    boletimSanitario: null,
    loading: true,
  }),
  computed: {
    medicamentosAdministrados() {
      let listaAdmFarmaco = []
      this.boletimSanitario.admFarmacos.forEach((adm, idx) => {
        listaAdmFarmaco.push(
            this.boletimSanitario.vacinas[idx] ?
                _.extend(adm, this.boletimSanitario.vacinas[idx]) :
                adm
        )
      })
      return listaAdmFarmaco
    },
  },
  props: {
    btnContinuar: Boolean,
    idBoletimSanitario: {
      type: Number,
    },
    step: Number,
  },
  methods: {
    loadBoletimSanitarioResumo() {
      this.loading = true
      this.$axios.get(`boletim-sanitario/${this.idBoletimSanitario}/boletim-sanitario-digital/`)
          .then(res => {
            if (!res.data) return

            this.boletimSanitario = res.data
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
          .finally(() => this.loading = false)
    }
  },
  filters: {
    somaTotalQtAnimaisSaida(lista) {
      if (!lista || lista.length === 0) return 0
      return lista.reduce((acc, origem) => acc + parseInt(origem.qtAnimaisSaida), 0)
    },
    somaTotalQtAnimais(lista) {
      if (!lista || lista.length === 0) return 0
      return lista.reduce((acc, saida) => acc + parseInt(saida.qtAnimais), 0)
    }
  },
  watch: {
    step: {
      handler(step) {
        if (!step || step !== 5) return
        if (!this.idBoletimSanitario) return
        this.loadBoletimSanitarioResumo()
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.route-view-card > div {
  background-color: #FFFFFF;
}


table, th, td {
  border-collapse: collapse;
  background-color: #FFFFFF;
  border: 1px solid #000000;
  font-family: Arial, serif;
  font-size: 14.0px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}

table {
  width: 100%;
  border-bottom: 0px;
  page-break-inside: avoid;
}

.grid-row3 {
  display: grid;
  grid-template-columns: 350px 350px auto;
}

.mb-2 {
  margin-bottom: 8px;
}

.dashed-b {
  border-bottom: 1px black dashed;
}

ol {
  padding: 0;
  list-style-type: none;
  counter-reset: orderedlist;
}

ol > li::before {
  counter-increment: orderedlist;
  content: counter(orderedlist) ' ::';
}

li {
  padding: 0 4px 8px 4px;
  border-bottom: 1px black dashed;
  margin-top: 4px;
}

.wrapper {
  padding: 4px;
  /* border: 1px solid #000000; */
}

.d-column {
  display: flex;
  flex-direction: column;
}

.border-r, .border-x {
  border-right: 1px solid #000000;
}

.border-l, .border-x {
  border-left: 1px solid #000000;
}

.border-b, .border-y {
  border-bottom: 1px solid #000000;
}

.border-t, .border-y {
  border-top: 1px solid #000000;
}

.header {
  text-align: center;
  background-color: rgb(192, 192, 192);
}

th {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
  background-color: rgb(192, 192, 192);
  font-weight: normal;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.p-data {
  padding: 4px 16px 4px 16px;
}

.borderless > td {
  border: 0px solid black;
}


.grid-info {
  display: grid;
  grid-template-columns: auto auto auto auto;
}

.center-icon {
  display: flex;
  justify-content: center;
  align-content: center;
}

.prevent-break {
  page-break-inside: avoid;
}

.sif-title {
  padding: 8px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.text_001 {
  font-family: Courier Prime, serif;
  font-size: 16px;
  color: rgb(100, 100, 100);
  font-weight: normal;
  font-style: normal;
  text-decoration: none
}

.text_002 {
  font-family: Arial, serif;
  font-size: 20.0px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-style: normal;
  text-decoration: none
}

</style>